import { useMemo } from "react";
import { Chart } from "@highcharts/react";
import "highcharts/es-modules/masters/modules/map.src.js";
import topo from "@highcharts/map-collection/countries/us/us-all.topo.json";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import BarChart from "../../../components/core/blocks/BarChart";
import getMetricSpec from "../../merchandising/utils/metrics";

const LocationChart = ({ regionData, geoData, metricOptions, onSelectMetric, selectedMetric }) => {
  const { t } = useTranslation(["dsp"]);
  const selectedMetricOptions = metricOptions.find((m) => m.value === selectedMetric);

  const metric = useMemo(() => getMetricSpec(selectedMetric), [selectedMetric]);

  const options = useMemo(() => {
    if (!geoData) {
      return null;
    }

    return {
      chart: {
        map: topo,
      },
      title: {
        text: "",
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: "bottom",
        },
      },
      colorAxis: {
        minColor: "#f7f7f7",
        maxColor: metric.color,
      },
      series: [
        {
          color: "#C0C0C0",
          borderColor: "#e6e6e6",
          type: "map",
          mapData: topo,
          data: geoData,
        },
      ],
    };
  }, [geoData, metric]);

  return (
    <>
      <Row>
        <Col xs={12} lg={10}></Col>
        <Col xs={12} lg={2}>
          <Select options={metricOptions} value={selectedMetricOptions} onChange={(e) => onSelectMetric(e.value)} />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <h5 className="text-center">{t(($) => $.dsp["United States"])}</h5>
          {options && <Chart options={options} chartConstructor="mapChart" />}
        </Col>
        <Col xs={6}>
          <BarChart
            accessor={metric.accessor}
            metric={selectedMetricOptions.label}
            title={t(($) => $.dsp["Region"])}
            data={regionData}
            colors={[metric.color]}
            categoryAccessor={(d) => d.region}
          />
        </Col>
      </Row>
    </>
  );
};

export default LocationChart;
